export default function EntranceButton({label,clickEvent}){
    return(
        <div className="entrance-button" onClick={clickEvent}>{label}</div>
    )
}